import { getInstrumentMeta } from '@/app/meta';
import { getInstruments } from '@/api/web-sdk';
import { getCurrentQuotes, getHistoryQuotes } from '@/api/gaterest-sdk';

/**
 * Builds objects for specified instruments
 * @param  {array} symbols An array of instrument symbol
 * @return {object} Returns a mapped object where
 * @example
 *     [
 *         {
 *             value: 1.23,         - the current value of instrument
 *             links: eur.com       -
 *             description: "lorem" -
 *             percentChange: 0.54, -
 *             symbol:"PA",         -
 *             alias: "Palladium",  -
 *             type":"future",      -
 *             "market":"Metals",   -
 *             "open":988.15,       -
 *             "high":995.37,       -
 *             "low":985.9,         -
 *             "close":993.52,      -
 *             "numDigit":2         -
 *          }
 *    ]
 */
export async function factory (lang, symbols) {
    const info = await getInstruments(lang, { symbols, fields: ['description', 'market', 'type'] });

    return (info['instruments'] || []).map(instrument => {
        const { c, o, l, h, p } = instrument.interval['D1'];
        return {
            value: instrument.rate,
            link: instrument.link,
            tradeLink: instrument.tradelink || null,
            percentChange: p.toFixed(2),
            symbol: instrument.code,
            alias: instrument.name,
            description: (instrument.description || { html: '', text: '' }).html,
            type: instrument.type || null,
            market: instrument.market,
            open: o,
            high: h,
            low: l,
            close: c
        };
    });
};

export async function history (symbol, interval = 'D1') {
    const quotes = await getHistoryQuotes(symbol, interval);
    return quotes.map((quote) => {
        let { dt, o, c, l, h } = quote;
        return [new Date(dt), o, c, l, h];
    });
};

export function getLbxLink (instrument) {
    return instrument.link || '#';
}

export function getInstrumentLink (instrument) {
    return getInstrumentMeta(instrument.symbol, 'link') || getLbxLink(instrument);
}

export function getInstrumentTradeLink (instrument) {
    return instrument.tradeLink || getLbxLink(instrument);
}



// WEBPACK FOOTER //
// ./src/utils/instruments.js